define('bindingHandlers/dialog',[
    'jquery',
    'lib/knockout'
], function (
    $,
    ko
) {
    'use strict';

    var HIDDEN_CSS_CLASS = "hidden";
    var DIALOG_CSS_CLASS = "dialog";

    /**
     * Display the contents of an element in an in-page dialog box. This widget will
     * display the dialog over other content in the page, but will not prevent interaction
     * with other elements on the page.
     *
     * @param {Boolean} isDisplayingDialog A boolean observable value that will determine
     * if the dialog box is displayed or not. True will display the dialog and false will
     * hide it.
     *
     * # Example
     *
     *     <div data-bind="dialog: isDisplayingDialog">Foo</div>
     */
    ko.bindingHandlers.dialog = {
        init: function (element) {
            var $element = $(element);

            $element
                .addClass(DIALOG_CSS_CLASS)
                .addClass(HIDDEN_CSS_CLASS);
        },
        update: function (element, valueAccessor) {
            var isDisplayingDialog = ko.unwrap(valueAccessor());
            var $element = $(element);

            if (isDisplayingDialog) {
                $element.removeClass(HIDDEN_CSS_CLASS);
            } else {
                $element.addClass(HIDDEN_CSS_CLASS);
            }
        }
    };
});
